'use strict';
declare var loaderConfigSalETF: any;
module Patersons {

    export interface  XrayScope extends ng.IScope {
        isLoading: boolean;
        securityId: string;
    }

    export class XrayCtrl extends AbstractController {
        scope: Patersons.XrayScope;
        timeout: any;

        static $inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', '$timeout'];

        constructor($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, $timeout) {
            super($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope);
            this.scope = $scope;
            this.load();
        }

        load() {
            this.log.info("Xray Ctrl loading...");
            let portfolio_xray = {
                name: 'demo portfolio 1',
                totalValue: 10000,
                currencyId: 'USD',
                holdings: [{
                    identifier: 'AU000000SFY4',
                    identifierType: 'ISIN',
                    weight: 50
                }, {
                    identifier: 'AU000000VAP7',
                    identifierType: 'ISIN',
                    weight: 30
                }, {
                    identifier: 'AU000000BHP4',
                    identifierType: 'ISIN',
                    weight: 10
                }, {
                    identifier: 'AU60PLA00028',
                    identifierType: 'ISIN',
                    weight: 10
                }],
                benchmark: {
                    holdings: [{
                        identifier: 'XIUSA04GJ2',
                        identifierType: 'MSID',
                        weight: 100
                    }]
                }
            };

            rootMorningstarPromise().then(function (
                promiseChain
            ) {
                console.log("initializing component");
                    initComponent('component-xray', 'ec-xray-container', 'ec-xray', 'ecXrayPats').then(function () {
                        morningstar.asterix.instanceRegistry.get('ecXrayPats').setParameter('portfolio', portfolio_xray);
                    });
            });
        }
    }
}
